import script from "./day.vue?vue&type=script&lang=ts&setup=true"
export * from "./day.vue?vue&type=script&lang=ts&setup=true"

import "./day.vue?vue&type=style&index=0&id=01c1eaca&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c1eaca"]])

export default __exports__